import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import { PromotionCard } from '@atlas/components';
import { SiteConfigManager } from '@atlas/core';
import { COMPONENT_TYPES } from '@atlas/routing';
import { Button, Icon } from '@atlas/ui';

import { CDN_TYPE_CMS, imageUrlCDN } from 'common/utils';

const Card = ({ buttonSize = 'big', promotion, showPromoButtons = true }) => {
  const { button: buttonText, description, id, image_url: imageUrl, layout, link } = promotion;
  const imgSrc = imageUrlCDN(imageUrl, CDN_TYPE_CMS);
  const promotions = SiteConfigManager.getComponentPath(COMPONENT_TYPES.PROMOTIONS);
  const promoDetailsPage = `${promotions}/${id}`;

  return (
    <PromotionCard
      ButtonComponent={() => (
        <Link to={link || promoDetailsPage}>
          <Button label={buttonText || 'promo_button_empty'} size={buttonSize} type="primary" />
        </Link>
      )}
      description={description}
      imageUrl={imgSrc}
      key={id}
      layoutType={layout}
      {...(link && {
        renderInfoButton: ({ className }) => (
          <Link className={className} to={promoDetailsPage}>
            <Icon height={18} name="info" width={18} />
          </Link>
        ),
      })}
      showPromoButtons={showPromoButtons}
    />
  );
};

Card.propTypes = {
  buttonSize: PropTypes.string,
  promotion: PropTypes.shape({
    button: PropTypes.string,
    description: PropTypes.string.isRequired,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    image_url: PropTypes.string,
    layout: PropTypes.oneOf(['labeled', 'default']),
    link: PropTypes.string,
  }),
  showPromoButtons: PropTypes.bool,
};

export default Card;
